import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Button, Message } from 'semantic-ui-react'
import { PATH_PRODUCTS_EDIT } from '../../../consts'
import { useQuery } from '../../../hooks/useQuery'
import { Alias } from '../../../redux/types/products'
import { deleteAlias } from './api/delete'

interface MessageType {
  error?: boolean
  positive?: true
  content?: string
  header?: string
}

export const DuplicateAlias = ({ duplicateAlias }: { duplicateAlias?: Alias }) => {
  const history = useHistory()
  const query = useQuery()
  const aliasId = query.get('aliasId')
  const returnUrl = query.get('returnUrl')
  const { productId } = useParams<{
    productId: string
  }>()
  const [message, setMessage] = useState<MessageType | undefined>()

  const removeDuplicateAlias = async () => {
    if (aliasId) {
      const [error, response] = await deleteAlias(aliasId, productId)

      if (response?.status === 204) {
        const pathName = returnUrl || PATH_PRODUCTS_EDIT

        history.push(pathName, {
          toast: {
            title: 'Alias removed succesfully',
            options: {
              containerId: 'default',
            },
          },
        })
      }

      if (error?.response?.status === 404) {
        setMessage({
          header: 'Already removed or does not exist',
          error: true,
          content: `Alias has already been removed from #${productId} or does not exist.`,
        })
      }
    }
  }

  return (
    <>
      {duplicateAlias && !message && (
        <Message error>
          <Message.Header>Alias already exists</Message.Header>
          <Message.Content>
            An alias with the same name already exists on this product.
          </Message.Content>
          <Button size="small" color="red" style={{ marginTop: 10 }} onClick={removeDuplicateAlias}>
            Remove from product #{productId}
          </Button>
        </Message>
      )}

      {message && <Message {...message} />}
    </>
  )
}
